/* EuroVan — Savings badge.
 *
 * Principles:
 *  - Every amount is rendered by Liquid's `money` filter and passed through a
 *    JSON map. No currency symbol is ever assembled here.
 *  - The badge markup already exists in the page (snippets/price.liquid) for
 *    the variant Liquid rendered, so the product page paints the right value
 *    with no flash. This script only keeps it in sync afterwards.
 *  - Which wording is visible is decided by CSS in sections/evs-savings-badge.liquid.
 *  - When the sticky bar badge is visible the bar gets .vls-satc--has-save, so
 *    the CSS can take width back from the variant select instead of overflowing.
 *
 * QA: ?evs_save=money|percent|both|verbose overrides the wording for one visit.
 */
(function () {
  'use strict';

  var CFG = window.EVS_SAVE || {};
  var FORMATS = ['money', 'percent', 'both', 'verbose'];
  var bound = false;

  function urlParam(name) {
    try {
      return new URLSearchParams(window.location.search).get(name);
    } catch (e) {
      return null;
    }
  }

  function data() {
    if (data.cache) return data.cache;
    var el = document.getElementById('evs-save-data');
    var out = {};
    if (el) {
      try { out = JSON.parse(el.textContent) || {}; } catch (e) { out = {}; }
    }
    data.cache = out;
    return out;
  }

  function minSave() {
    var n = parseInt(CFG.minSave, 10);
    return isNaN(n) ? 0 : n;
  }

  /* QA override: swap the rule that decides the visible wording. */
  function applyFormatOverride() {
    var fmt = urlParam('evs_save');
    if (!fmt || FORMATS.indexOf(fmt) === -1 || fmt === CFG.format) return;
    var css = '.evs-save > span{display:none}.evs-save > .evs-save__' + fmt + '{display:inline}';
    if (fmt === 'both') {
      css = '.evs-save > span{display:none}' +
            '.evs-save > .evs-save__money,.evs-save > .evs-save__percent{display:inline}' +
            '.evs-save > .evs-save__percent::before{content:" · ";font-weight:400;opacity:.75}';
    }
    var style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);
  }

  function productScope() {
    return document.querySelector('.product.js-product');
  }

  function currentVariantId() {
    var scope = productScope();
    if (!scope) return null;
    var form = scope.querySelector('.js-product-form-main');
    var input = form ? form.querySelector('input[name="id"]') : null;
    return input ? input.value : null;
  }

  /* ---- Writing one badge ---------------------------------------------- */

  function fill(badge, entry) {
    if (!badge) return;

    if (!entry || !entry.on || entry.raw < minSave()) {
      badge.hidden = true;
      return;
    }

    var m = badge.querySelector('[data-evs-save-money]');
    var p = badge.querySelector('[data-evs-save-percent]');
    var v = badge.querySelector('[data-evs-save-verbose]');

    if (m) m.textContent = entry.money;
    if (p) p.textContent = entry.percent;
    /* The spelled-out wording is an _html translation string. */
    if (v) v.innerHTML = entry.verbose;

    badge.setAttribute('data-evs-raw', entry.raw);
    badge.hidden = false;
  }

  /* Badges Liquid rendered outside the product page (cards) only need the
     minimum-saving rule applied; their amounts are already correct. */
  function enforceMinimumEverywhere() {
    var min = minSave();
    if (!min) return;
    var all = document.querySelectorAll('[data-evs-save]');
    for (var i = 0; i < all.length; i += 1) {
      var raw = parseInt(all[i].getAttribute('data-evs-raw'), 10);
      if (!isNaN(raw) && raw < min) all[i].hidden = true;
    }
  }

  /* ---- The sticky bar badge ------------------------------------------- */

  function buildBadge() {
    var badge = document.createElement('span');
    badge.className = 'evs-save';
    badge.setAttribute('data-evs-save', '');
    badge.hidden = true;

    [['money', 'evs-save__money'],
     ['percent', 'evs-save__percent'],
     ['verbose', 'evs-save__verbose']].forEach(function (pair) {
      var span = document.createElement('span');
      span.className = pair[1];
      span.setAttribute('data-evs-save-' + pair[0], '');
      badge.appendChild(span);
    });

    return badge;
  }

  function stickyBadge() {
    var bar = document.querySelector('.vls-satc');
    if (!bar) return null;

    var existing = bar.querySelector('[data-evs-save]');
    if (existing) return existing;

    var row = bar.querySelector('.vls-satc__row--selection');
    var price = bar.querySelector('.vls-satc__price');
    if (!row) return null;

    var badge = buildBadge();
    if (price && price.parentNode === row) {
      row.insertBefore(badge, price.nextSibling);
    } else {
      row.appendChild(badge);
    }
    return badge;
  }

  /* ---- Sync ------------------------------------------------------------ */

  function sync() {
    var map = data();
    var id = currentVariantId();
    if (!id) return;

    var entry = map[String(id)];

    if (CFG.pdp !== false) {
      var block = document.querySelector('.product-info__price');
      if (block) {
        var badges = block.querySelectorAll('[data-evs-save]');
        for (var i = 0; i < badges.length; i += 1) fill(badges[i], entry);
      }
    }

    if (CFG.satc) {
      var sb = stickyBadge();
      fill(sb, entry);
      var bar = document.querySelector('.vls-satc');
      if (bar && sb) bar.classList.toggle('vls-satc--has-save', !sb.hidden);
    }
  }

  function init() {
    applyFormatOverride();
    enforceMinimumEverywhere();
    sync();

    if (bound) return;
    bound = true;

    document.addEventListener('on:variant:change', sync);
    document.addEventListener('shopify:section:load', function () {
      data.cache = null;
      init();
    });

    /* Fallback: some apps write the hidden id input directly. */
    var scope = productScope();
    var form = scope ? scope.querySelector('.js-product-form-main') : null;
    var input = form ? form.querySelector('input[name="id"]') : null;
    if (input && window.MutationObserver) {
      new MutationObserver(sync).observe(input, { attributes: true, attributeFilter: ['value'] });
      input.addEventListener('change', sync);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
